import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from 'app/lib/utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...rest }, ref) => (
    <label ref={ref} className={cn(className)} {...rest} />
  )
);

Label.displayName = 'Label';

export default Label;
